import React, { useEffect,useImperativeHandle, useRef } from 'react'
import { copyDeep, isEqual, isEmpty, isDict } from 'libs/utils'
import api from 'libs/api'
import useForm from 'apps/hooks/useForm'
import { Skeleton } from 'antd'
const search = new URLSearchParams(window.location.search)


 const ParticipantRegistrationForm = React.forwardRef((props, ref) => {

    const data = props.data ? props.data : {}

    const getDefaultValue = (field) => search.get(field.mapField) !== null ? search.get(field.mapField) :
    field.defaultValue || (
        field.mapField === "first_name" ? (props.user?.first_name) || "" :
          field.mapField === "last_name" ? (props.user?.last_name) || "" :
            field.mapField === "email" ? (props.user?.email) || "" : ""
    )
    const [formData, setFormData] = React.useState()
    const [dataChanged, setDataChanged] = React.useState(false);
   const fieldsData = React.useMemo(() => {
        return (data?.fields || []).reduce((acc, field) => {
            if (field?.fields) {
            acc.push(...field.fields);
            }
            return acc;
        }, []);
        }, [data]);

// 2️⃣ Build initialValues based on mapField & getDefaultValue
const initialData = React.useMemo(() => {
  return fieldsData.reduce((acc, field) => {
    if (field.mapField) {
      acc[field.mapField] = getDefaultValue(field);
    }
    return acc;
  }, {});
}, [fieldsData]);


// 3️⃣ Bind directly into useForm
const [
  participantForm,
  participantCurrentValues,
  participantIsValid,
  participantValidateForm
] = useForm({
  fields: fieldsData,
  initialValues: initialData,
    mapping_key: 'mapField',
    mapping_key2: 'mapField2',
    horizontal: false,
    horizontalLabelSize: 1,
    horizontalInputSize: 10,
    className: 'participant-registration-form',
    validate: true,
    grid:true
});

const initialValuesRef = useRef(null);

// store initial form values once, when component mounts or form loads
// useEffect(() => {
//   initialValuesRef.current = participantCurrentValues;
// }, [participantCurrentValues]); // or when form resets
// console.log("Initial Values Ref:", initialValuesRef.current);
// console.log("Participant Current Values:", participantCurrentValues);


// Effect to set initial values and detect changes
  React.useEffect(() => {
    // Set initial values only once
    if (initialValuesRef.current === null) {
      initialValuesRef.current = {...participantCurrentValues};
    }
    
    // Compare current values with initial values
    const hasChanged = !isEqual(participantCurrentValues, initialValuesRef.current);
    setDataChanged(hasChanged);

  }, [participantCurrentValues]);

//  Create a ref to access the form methods
  useImperativeHandle(ref,()=>{
    try {
      return {
        validate: () => {
          const isValid = participantValidateForm();
          if (!isValid) {
            console.error("Participant form validation failed");
          }
          return isValid;
        },
        getValues: () => participantCurrentValues,
        dataChanged: dataChanged,
        resetDataChanged: () => {
          initialValuesRef.current = {...participantCurrentValues};
          setDataChanged(false);
        },
        datas:()=>{
          return {
            currentValues: participantCurrentValues,
            prevValues: initialValuesRef.current,
          }
        }
      };
    } catch (error) {
      console.error("Error in useImperativeHandle:", error);
      return false;
    }
  },[participantCurrentValues, participantValidateForm]);

  return (
    <div style={{ padding: '20px', height: '400px',overflow:'auto',overflowX:'hidden',textAlign:'left' }}>{props?.isLoading ? <Skeleton active /> : participantForm}</div>
  )
});
ParticipantRegistrationForm.displayName = 'ParticipantRegistrationForm';
export default ParticipantRegistrationForm;

